<script>
const _sizes = {
  m: {
    maxWidth: '94px',
    maxHeight: '30px',
  },
  s: {
    maxWidth: '45px',
    maxHeight: '30px',
  },
  l: {
    maxWidth: '112px',
    maxHeight: '36px',
  },
  xl: {
    maxWidth: '130px',
    maxHeight: '42px',
  },
};

const availableLogos = {
  s_white: new URL('@/assets/img/s_logo_cropped_brand_white.webp', import.meta.url),
  s_default: new URL('@/assets/img/s_logo_cropped_brand.webp', import.meta.url),

  white: new URL('@/assets/img/logo_cropped_brand_white.webp', import.meta.url),
  default: new URL('@/assets/img/logo_cropped_brand.webp', import.meta.url),
};

export default {
  name: 'SiteLogo',

  functional: true,

  props: {
    size: {
      type: String,
      required: true,
      validator: (value) => _sizes[value] != null,
    },

    smallVariant: {
      type: Boolean,
      default: false,
    },

    isWhite: {
      type: Boolean,
      default: false,
    },
  },

  render(h, ctx) {
    const logoKey = (ctx.props.smallVariant ? 's_' : '') + (ctx.props.isWhite ? 'white' : 'default');

    return h('img', {
      class: ctx.data.class,
      staticClass: ctx.data.staticClass,
      staticStyle: ctx.data.staticStyle,
      on: ctx.listeners,
      style: Object.assign({}, _sizes[ctx.props.size], ctx.data.style),
      attrs: Object.assign({}, { src: availableLogos[logoKey], alt: 'ReMoney' }, ctx.data.attrs),
    });
  },
};
</script>
